export const AI_MATE_ATTRIBUTES = {
  conversationChannelId: 'conversationChannelId',
  experienceId: 'experienceId',
  product: 'product',
  agentId: 'agentId',
  fullScreen: 'fullScreen'
};